import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Page first"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-page-first',
    templateUrl: './icon-page-first.component.html',
    styleUrls: ['./icon-page-first.component.scss'],
    standalone: false
})
export class IconPageFirstComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
